
import Parse from '../../parseConfig';

const getParseFileName = (file) => {
  if (!file) return '';

  const fileName =
    typeof file.name === 'function'
      ? file.name()
      : file._name || file.name || '';

  const separatorIndex = fileName.indexOf('_');
  if (separatorIndex === -1) {
    return fileName;
  }

  return fileName.slice(separatorIndex + 1);
};

/**
 * Fetches stock listings from the "HouseLand" class in Parse.
 * Returns an array of cleaned objects ready for map + sidebar use.
 */
export async function fetchStockData({ includeInactive = false } = {}) {

  const HouseLand = Parse.Object.extend('HouseLand');
  const q = new Parse.Query(HouseLand);

  // Limit results
  q.limit(500);
  q.include('associatedMapLayer');

  // Public stock page excludes inactive listings, but the admin modal needs the full set.
  if (!includeInactive) {
    q.notEqualTo('inactive', 1);
  }

  // Select only needed fields
  q.select([
    'trademeURL',
    'coordinates',
    'locationString',
    'availability',
    'inactive',
    'progress',
    'displayTitle',
    'price',
    'associatedMapLayer',
    'bedrooms',
    'bathrooms',
    'floorArea',
    'landArea',
    'thumb',
    'buildSpec',
    'franchise',
    'brochure',
  ]);

  const results = await q.find();

  return results.map((r) => {

    const coords = r.get('coordinates');
    const associatedMapLayer = r.get('associatedMapLayer');
    const thumbFile = r.get('thumb');
    const brochureFile = r.get('brochure');

    return {

      id: r.id,
      createdAt: r.createdAt ? r.createdAt.toISOString() : null,
      trademeURL: r.get('trademeURL') || '',
      coordinates: coords
        ? { lat: coords.latitude, lng: coords.longitude }
        : null,
      availability: r.get('availability') || '',
      inactive: r.get('inactive') === 1,
      locationString: r.get('locationString') || '',
      progress: r.get('progress') || '',
      displayTitle: r.get('displayTitle') || '',
      price: r.get('price') || '',
      associatedMapLayerId: associatedMapLayer ? associatedMapLayer.id : null,
      associatedMapLayerName: associatedMapLayer?.get?.('name') || '',
      bedrooms: r.get('bedrooms') || null,
      bathrooms: r.get('bathrooms') || null,
      floorArea: r.get('floorArea') || null,
      landArea: r.get('landArea') || null,
      buildSpec: r.get('buildSpec') || null,
      franchise: r.get('franchise') || null,
      thumbnail: thumbFile ? thumbFile.url() : null,
      thumbnailName: getParseFileName(thumbFile),
      brochure: brochureFile ? brochureFile.url() : null,
      brochureName: getParseFileName(brochureFile),
      _raw: r,
    };
  });
}
